"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreejsEditorModal = void 0;
var _made = require("@exabyte-io/made.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var THREE = _interopRequireWildcard(require("three"));
var _RemoveMultipleSelectionGroupCommand = require("three/editor/js/commands/RemoveMultipleSelectionGroupCommand");
var _SetSceneCommand = require("three/editor/js/commands/SetSceneCommand");
var _SubmitMultipleSelectionCommand = require("three/editor/js/commands/SubmitMultipleSelectionCommand");
var _Editor = require("three/editor/js/Editor");
var _Menubar = require("three/editor/js/Menubar");
var _Player = require("three/editor/js/Player");
var _Script = require("three/editor/js/Script");
var _Sidebar = require("three/editor/js/Sidebar");
var _Toolbar = require("three/editor/js/Toolbar");
var _Viewport = require("three/editor/js/Viewport");
var _OrbitControls = require("three/examples/jsm/controls/OrbitControls");
var _enums = require("../enums");
var _settings = _interopRequireDefault(require("../settings"));
var _utils = require("../utils");
var _AlertDialog = require("./AlertDialog");
var _ModalDialog = require("./ModalDialog");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ThreejsEditorModal extends _ModalDialog.ModalDialog {
  constructor(props) {
    super(props);
    _defineProperty(this, "initializeCamera", () => {
      // create a PerspectiveCamera at specific position and pass to the editor to override the default one.
      const camera = new THREE.PerspectiveCamera(50, 1, 0.01, 20000);
      camera.name = "Camera";
      camera.position.copy(new THREE.Vector3(0, -20, 8));
      camera.lookAt(new THREE.Vector3(0, 0, 0));
      return camera;
    });
    this.editor = undefined;
    this.domElement = undefined;
    this.showAlert = this.showAlert.bind(this);
    this.submitMultipleSelectionGroup = this.submitMultipleSelectionGroup.bind(this);
    this.removeMultipleSelectionGroup = this.removeMultipleSelectionGroup.bind(this);
    this.showSubmissionMultipleSelectionModal = this.showSubmissionMultipleSelectionModal.bind(this);
    this.isMultipleSelectionGroupSubmitted = this.isMultipleSelectionGroupSubmitted.bind(this);
    this.forceExitFromEditor = this.forceExitFromEditor.bind(this);
    this.exitWithCallback = this.exitWithCallback.bind(this);
    this.extractMaterialAndHide = this.extractMaterialAndHide.bind(this);
    this.onExtractMaterialError = this.onExtractMaterialError.bind(this);
  }
  initialize(el) {
    if (!el) return;
    this.domElement = el;
    this.setNumberFormat();
    this.initializeEditor();
    this.addEventListeners();
    this.addSignalsListeners();
    this.loadScene();
    this.initializeRaycaster();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    window.localStorage.removeItem("threejs-editor");
  }

  /**
   * `Number.prototype.format` is used inside three.js editor codebase to format the numbers.
   * The editor does not start without it. The ESLint line is a way to turn off the warning shown in the console.
   */
  // eslint-disable-next-line class-methods-use-this
  setNumberFormat() {
    /* eslint func-names: ["off"] */
    /* eslint no-extend-native: [0, { "exceptions": ["Object"] }] */
    Number.prototype.format = function () {
      return this.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };
  }
  initializeLights() {
    const directionalLight = new THREE.DirectionalLight("#FFFFFF");
    directionalLight.position.copy(new THREE.Vector3(0.2, 0.2, -1).normalize());
    directionalLight.intensity = 1.2;
    this.editor.scene.add(directionalLight);
  }
  initializeControlsInEditor() {
    // initialize controls
    this.editor.controls = new _OrbitControls.OrbitControls(this.editor.camera, this.viewport.dom);
    this.editor.controls.up = new THREE.Vector3(0, 0, 1);
    this.editor.controls.target.set(0, 0, 0);
    // set controls parameters
    this.editor.controls.panSpeed = 0.1;
    this.editor.controls.rotateSpeed = 2.0;
    this.editor.controls.zoomSpeed = 0.2;
  }
  initializeRaycaster() {
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();
    const cell = this.editor.scene.getObjectByName("Cell");
    const labels = this.editor.scene.getObjectByName(_enums.LABELS_GROUP_NAME).children;
    // Make the cell and labels transparent for raycaster so they do not block atoms
    cell.raycast = () => {};
    labels.forEach(label => {
      label.raycast = () => {};
    });
  }

  /**
   * Initialize threejs editor and add it to the DOM.
   */
  initializeEditor() {
    // adjust the orientation to have Z-axis up/down
    THREE.Object3D.DefaultUp.set(0, 0, 1);

    // initialize editor and set the scene background
    this.editor = new _Editor.Editor(this.initializeCamera());
    this.editor.scene.background = new THREE.Color(_settings.default.backgroundColor);

    // pass onHide handler to editor
    this.editor.onHide = this.onHide;

    // initialize viewport and add it to the DOM
    this.viewport = new _Viewport.Viewport(this.editor);
    this.domElement.appendChild(this.viewport.dom);

    // initialize UI elements and add them to the DOM
    const script = new _Script.Script(this.editor);
    this.domElement.appendChild(script.dom);
    const player = new _Player.Player(this.editor);
    this.domElement.appendChild(player.dom);
    const menubar = new _Menubar.Menubar(this.editor);
    this.domElement.appendChild(menubar.dom);
    const sidebar = new _Sidebar.Sidebar(this.editor);
    this.domElement.appendChild(sidebar.dom);
    const toolbar = new _Toolbar.Toolbar(this.editor);
    this.domElement.appendChild(toolbar.dom);
    this.initializeControlsInEditor();
    this.initializeLights();
  }

  /**
   * Add dragover listeners to group the objects.
   */
  addEventListeners() {
    // This is a hack to disable Orbit Controls when Multiple Selection button is toggled.
    // It detects if the word "selected" is in the classname of the button element.
    // This conforms to previous behavior of controls during the operation.
    const isMultipleSelectionActive = () => {
      const toggleButton = document.querySelector(".ms-button__toggle");
      return toggleButton && toggleButton.classList.contains("selected");
    };
    document.addEventListener("dragover", event => {
      event.preventDefault();
      event.dataTransfer.dropEffect = "copy";
    }, false);
    document.addEventListener("mousedown", event => {
      // on right click and hold disable orbit controls to allow pan
      if (event.button === THREE.MOUSE.RIGHT) {
        this.editor.controls.enabled = false;
        return;
      }

      // on a left click detect if the click was on the object of type Mesh and disable orbit controls in that case
      // Conveniently, the only objects of type Mesh are Atoms and Transform Controls
      if (event.button === THREE.MOUSE.LEFT) {
        // calculate mouse position in normalized viewport coordinates
        // https://threejs.org/docs/#api/en/core/Raycaster
        const view = this.viewport.dom.getBoundingClientRect();
        this.mouse.x = (event.clientX - view.left) / view.width * 2 - 1;
        this.mouse.y = -((event.clientY - view.top) / view.height) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.editor.camera);
        const objects = this.editor.scene.children;
        const helpers = this.editor.sceneHelpers.children;
        const intersects = this.raycaster.intersectObjects([...objects, ...helpers], true);

        // Check if any of the intersected objects is of type Mesh (only Atoms and Transform Controls are of that type)
        const hasMeshIntersect = intersects.some(intersect => intersect.object.type === "Mesh");
        this.editor.controls.enabled = !hasMeshIntersect && !isMultipleSelectionActive();
      }
    });
    document.addEventListener("mouseup", event => {
      // on right click release enable orbit controls after pan
      if (event.button === THREE.MOUSE.RIGHT) {
        this.editor.controls.enabled = true;
      }
      // on left click release enable orbit controls (return them to the default state)
      if (event.button === THREE.MOUSE.LEFT) {
        this.editor.controls.enabled = true;
      }
    });
    const onResize = () => this.editor.signals.windowResize.dispatch();
    window.addEventListener("resize", onResize, false);
    onResize();
  }

  /**
   * Handle signals from the editor
   */
  addSignalsListeners() {
    this.editor.signals.editorClosed.add(() => {
      this.onHide();
    });
  }

  /**
   * Load the scene based on the given materials.
   */
  loadScene() {
    const loader = new THREE.ObjectLoader();
    const scene = loader.parse((0, _utils.materialsToThreeDSceneData)(this.props.materials));
    this.editor.execute(new _SetSceneCommand.SetSceneCommand(this.editor, scene));
    this.editor.signals.objectSelected.dispatch(this.editor.camera);
  }

  /**
   *  shows alert with specific parameters
   *  @typedef {{ text: string, onClick: Function }} ButtonsType
   *  @typedef {{ title: string, content: string, buttons: ButtonsType }} ShowAlertInputType
   *  @param {ShowAlertInputType} params
   */
  showAlert(params) {
    this.alertRef.open(params);
  }

  /**
   * submits multiple selections group
   */
  submitMultipleSelectionGroup() {
    this.editor.execute(new _SubmitMultipleSelectionCommand.SubmitMultipleSelectionCommand(this.editor, this.editor.multipleSelection));
  }

  /**
   * removes multiple selection group
   */
  removeMultipleSelectionGroup() {
    this.editor.execute(new _RemoveMultipleSelectionGroupCommand.RemoveMultipleSelectionGroupCommand(this.editor));
  }

  /**
   * this function shows confirm window if user forgets to submit multiple selection and tries to exit from editor
   */
  // TODO: probably this logic could be moved to three js library into 3DEditor, when 3DEditor will use a React library.
  showSubmissionMultipleSelectionModal() {
    this.showAlert({
      title: "Warning!",
      content: "Multiple selection group is not submitted do you want submit and exit or undo latest changes?",
      buttons: [{
        text: "Close",
        onClick: this.alertRef.close
      }, {
        text: "Undo and Exit",
        onClick: this.exitWithCallback(this.removeMultipleSelectionGroup)
      }, {
        text: "Submit and Exit",
        onClick: this.exitWithCallback(this.submitMultipleSelectionGroup)
      }]
    });
  }

  /**
   * checks is multiple selection submitted
   * @returns {Boolean} true - if multiple selection is submitted false - if not
   */
  isMultipleSelectionGroupSubmitted() {
    const {
      scene
    } = this.editor;
    const multipleSelectionGroup = scene.getObjectByProperty("type", "MultipleSelectionGroup");
    return !multipleSelectionGroup;
  }

  /**
   * force exit from the modal with initially defined materials
   */
  forceExitFromEditor() {
    super.onHide(this.materials);
  }

  /**
   * exit form editor and calls callback
   * @param {Function} callback - function that should be called before exit from editor
   * @returns {Function} - callback that can be applied to event listener
   */
  exitWithCallback(callback) {
    return () => {
      callback();
      this.extractMaterialAndHide();
    };
  }

  /**
   * extracts materials and hides editor
   */
  extractMaterialAndHide() {
    try {
      const material = (0, _utils.ThreeDSceneDataToMaterial)(this.editor.scene);
      super.onHide(material);
    } catch {
      this.onExtractMaterialError();
    }
  }

  /**
   * displays error confirm window if we have some errors
   */
  onExtractMaterialError() {
    this.showAlert({
      content: "Unable to extract a material from the editor!",
      title: "Error!",
      buttons: [{
        text: "Close",
        onClick: this.alertRef.close
      }, {
        text: "Exit",
        onClick: this.forceExitFromEditor
      }]
    });
  }

  /**
   * function to be called on Escape click or on exit from editor
   */
  onHide() {
    try {
      const isMultipleSelectionGroupSubmitted = this.isMultipleSelectionGroupSubmitted();
      if (!isMultipleSelectionGroupSubmitted) {
        this.showSubmissionMultipleSelectionModal();
      } else {
        this.extractMaterialAndHide();
      }
    } catch {
      this.onExtractMaterialError();
    }
  }
  renderBody() {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.ModalBody, null, /*#__PURE__*/_react.default.createElement(_AlertDialog.AlertDialog, {
      ref: ref => this.alertRef = ref
    }), /*#__PURE__*/_react.default.createElement("div", {
      ref: el => this.initialize(el)
    }));
  }
}
exports.ThreejsEditorModal = ThreejsEditorModal;
ThreejsEditorModal.propTypes = {
  materials: _propTypes.default.arrayOf(_made.Made.Material).isRequired
};